import produce from "immer";
import AuthService from '../AuthService';
import { EVO } from '../EVO';
import { urls } from "../urls";
import { defaultClient } from "../defaultValues";

const GET_CLIENTS = 'peptalkr/Clients/GET_CLIENTS';
const GET_CLIENTS_SUCCESS = 'peptalkr/Clients/GET_CLIENTS_SUCCESS';
const GET_CLIENTS_FAILURE = 'peptalkr/Clients/GET_CLIENTS_FAILURE';
export const requestClients = () => ({ type: GET_CLIENTS });
export const receiveClients = (clients, id, redirect) => ({ type: GET_CLIENTS_SUCCESS, clients, id, redirect });
export const receiveClientsFail = error => ({ type: GET_CLIENTS_FAILURE, error });

const GET_NEW_CLIENT = 'peptalkr/Clients/GET_NEW_CLIENT';
const GET_CLIENT = 'peptalkr/Clients/GET_CLIENT';
const GET_CLIENT_SUCCESS = 'peptalkr/Clients/GET_CLIENT_SUCCESS';
const GET_CLIENT_FAILURE = 'peptalkr/Clients/GET_CLIENT_FAILURE';
export const receiveNewClient = (client) => ({ type: GET_NEW_CLIENT, client });
export const requestClient = () => ({ type: GET_CLIENT });
export const receiveClient = (clientDetails) => ({ type: GET_CLIENT_SUCCESS, clientDetails });
export const receiveClientFail = error => ({ type: GET_CLIENT_FAILURE, error });

const ADD_CLIENT = 'peptalkr/Client/ADD_CLIENT';
const ADD_CLIENT_SUCCESS = 'peptalkr/Client/ADD_CLIENT_SUCCESS';
const ADD_CLIENT_FAILURE = 'peptalkr/Client/ADD_CLIENT_FAILURE';
export const addClient = () => ({ type: ADD_CLIENT });
export const addClientSuccess = clientDetails => ({ type: ADD_CLIENT_SUCCESS, clientDetails });
export const addClientFailure = error => ({ type: ADD_CLIENT_FAILURE, error });

const DELETE_CLIENT = 'peptalkr/Client/DELETE_CLIENT';
const DELETE_CLIENT_SUCCESS = 'peptalkr/Client/DELETE_CLIENT_SUCCESS';
const DELETE_CLIENT_FAILURE = 'peptalkr/Client/DELETE_CLIENT_FAILURE';
export const deleteClient = () => ({ type: DELETE_CLIENT });
export const deleteClientSuccess = clients => ({ type: DELETE_CLIENT_SUCCESS, clients });
export const deleteClientFailure = error => ({ type: DELETE_CLIENT_FAILURE, error });

const SYNC_CLIENT = 'peptalkr/Client/SYNC_CLIENT';
const SYNC_CLIENT_SUCCESS = 'peptalkr/Client/SYNC_CLIENT_SUCCESS';
const SYNC_CLIENT_FAILURE = 'peptalkr/Client/SYNC_CLIENT_FAILURE';
export const syncClient = () => ({ type: SYNC_CLIENT });
export const syncClientSuccess = () => ({ type: SYNC_CLIENT_SUCCESS });
export const syncClientFailure = error => ({ type: SYNC_CLIENT_FAILURE, error });

export const fetchclients = (props) => (dispatch) => {
    const id = EVO.getParamsId(props);
    if (id && id === 'new') {
        dispatch(receiveNewClient(defaultClient))
    }
    else if (props && props.clients) {
        dispatch(receiveClients(props.clients, id))
    }
    else {
        const authService = new AuthService();
        const redirect = !!props.redirectToDetails;
        if (authService.isAuthenticated()) {
            dispatch(requestClients());
            EVO.fetch(urls.api.clients.getAll)
                .then(response => {
                    dispatch(receiveClients(response.clients, id, redirect));
                })
                .catch(error => dispatch(receiveClientsFail(error)));
        }
    }
};

export const fetchClientDetails = (id) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(requestClient());
        return EVO.fetch(urls.api.clients.get(id))
            .then(response => {
                dispatch(receiveClient(response));
            })
            .catch(error => {
                dispatch(receiveClientFail(error));
            });

    }
};

export const fetchMainClientDetails = () => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(requestClient());
        return EVO.fetch(urls.api.clients.getMain)
            .then(response => {
                dispatch(receiveClient(response));
            })
            .catch(error => {
                dispatch(receiveClientFail(error));
            });

    }
};

export const deleteClientFromPT = (id) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(deleteClient());
        return EVO.fetch(urls.api.clients.delete(id))
            .then(response => {
                dispatch(deleteClientSuccess(response.clients));
                EVO.success('Client deleted');
            })
            .catch(error => {
                dispatch(deleteClientFailure(error));
            });
    }
};

export const runSync = (data) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(syncClient());
        return EVO.fetch(urls.api.clients.sync, data)
            .then(response => {
                dispatch(syncClientSuccess(response.clients));
                EVO.success(response.message || 'Sync has been started. This is a background process and can take a while to execute.');
            })
            .catch(error => {
                dispatch(syncClientFailure(error));
            });
    }
};

export const runSyncAllToCM = (skipCliniko) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(syncClient());
        return EVO.fetch(urls.api.clients.syncAllToCM(skipCliniko))
            .then(response => {
                dispatch(syncClientSuccess(response.clients));
                EVO.success(response.message || 'Sync has been started. This is a background process and can take a while to execute.');
            })
            .catch(error => {
                dispatch(syncClientFailure(error));
            });
    }
};

export const addOrUpdateItem = (item) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        dispatch(addClient());
        return EVO.fetch(item.id ? urls.api.clients.update : urls.api.clients.add, item)
            .then(response => dispatch(addClientSuccess(response)))
            .then(() => EVO.success('Settings saved'))
            .catch(error => dispatch(addClientFailure(error)));
    }
};

export const updateTransactionalEmail = (data) => (dispatch) => {
    if (AuthService.getInstance().isAuthenticated()) {
        return EVO.fetch(urls.api.clients.updateTransactionalEmail, data)
            .then(response => dispatch(addClientSuccess(response)))
            .then(() => EVO.success(data.updating ? 'Email template successfully saved' : (data.active ? 'Email successfully enabled' : 'Email successfully disabled')))
            .catch(error => dispatch(addClientFailure(error)));
    }
};



const initialState = {
    clients: null,
    client: defaultClient,
    loading: true,
    error: false,
    chores: [],
    cmEmails: [],
    cmSegments: [],
    cmLists: [],
    loadingDetails: true,
    id: null,
    syncing: false,
    allTags: [],
    monthlyLimits: []
};

export default produce((draft, action) => {
    switch (action.type) {
        case GET_CLIENTS:
            draft.loading = true;
            return;
        case GET_CLIENTS_SUCCESS:
            draft.clients = action.clients;
            let id = action.id;
            if (action.id === 'main' && action.clients && action.clients.length > 0) {
                id = action.clients[0].id;
            }
            draft.client = action.id ? EVO.getDetailsItemById(action.clients, id, defaultClient) : null;
            draft.id = id;
            if (action.redirect) {
                draft.redirect = action.clients && action.clients.length > 0 ? `/clients/${action.clients[0].id}` : '/clients/new';
            }
            else {
                draft.loading = false;
            }
            return;
        case GET_CLIENTS_FAILURE:
            draft.loading = false;
            draft.error = action.error;
            draft.id = null;
            return;
        case GET_NEW_CLIENT:
            draft.loading = false;
            draft.loadingDetails = false;
            draft.client = Object.assign(EVO.clone(defaultClient), action.client);
            return;
        case GET_CLIENT:
            draft.loadingDetails = true;
            draft.chores = [];
            draft.cmEmails = []
            draft.cmSegments = [];
            draft.cmLists = [];
            return;
        case GET_CLIENT_SUCCESS:
            draft.loading = false;
            draft.loadingDetails = false;
            draft.chores = action.clientDetails.chores;
            draft.cmEmails = action.clientDetails.cmEmails;
            draft.cmSegments = action.clientDetails.cmSegments;
            draft.cmLists= action.clientDetails.cmLists;
            draft.id = action.clientDetails.client.id;
            draft.allTags = action.clientDetails.allTags;
            draft.client = Object.assign(EVO.clone(defaultClient), action.clientDetails.client);
            draft.monthlyLimits = action.clientDetails.monthlyLimits;
            return;
        case GET_CLIENT_FAILURE:
            draft.error = action.error;
            draft.loadingDetails = false;
            return;
        case ADD_CLIENT:
            // nothing to do.. Formik handles it
            return;
        case ADD_CLIENT_SUCCESS:
            draft.chores = action.clientDetails.chores;
            draft.cmEmails = action.clientDetails.cmEmails;
            draft.cmSegments = action.clientDetails.cmSegments;
            draft.cmLists = action.clientDetails.cmLists;
            draft.id = action.clientDetails.client.id;
            draft.client = Object.assign(EVO.clone(defaultClient), action.clientDetails.client);
            return;
        case ADD_CLIENT_FAILURE:
            draft.error = action.error;
            return;
        case DELETE_CLIENT:
            // nothing to do.. Formik handles it
            return;
        case DELETE_CLIENT_SUCCESS:
            draft.client = defaultClient;
            draft.clients = action.clients
            return;
        case DELETE_CLIENT_FAILURE:
            draft.error = action.error;
            return;
        case SYNC_CLIENT:
            draft.syncing = true;
            return;
        case SYNC_CLIENT_SUCCESS:
            draft.syncing = false;
            return;
        case SYNC_CLIENT_FAILURE:
            draft.syncing = false;
            draft.error = action.error;
            return;
        default: return;
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/clients.js